import { useCallback, useEffect, useState } from "react";
import { getAnnouncementsUnreadCount } from "../utils/announcementsCache";

/**
 * Lightweight unread count for sidebar badge (comunicados).
 */
export function useAnnouncementsUnreadCount(enabled) {
  const [unreadCount, setUnreadCount] = useState(0);

  const refresh = useCallback(async (signal) => {
    if (!enabled) {
      setUnreadCount(0);
      return;
    }
    try {
      const nextUnreadCount = await getAnnouncementsUnreadCount();
      if (signal?.aborted) return;
      setUnreadCount(nextUnreadCount);
    } catch (err) {
      if (err.name !== "AbortError") {
        setUnreadCount(0);
      }
    }
  }, [enabled]);

  useEffect(() => {
    const controller = new AbortController();
    refresh(controller.signal);
    return () => controller.abort();
  }, [refresh]);

  return { unreadCount, refreshUnreadCount: refresh };
}
